module.exports = __webpack_public_path__ + "img/purple-sky.52bc6b2e.png";